import { MachinesListDataTypes } from "@common/types/machines-list-types";
import apiUseCases from "@src/cloud-connect/api";
import { postVPNCancelSupportSessionDto } from "@src/cloud-connect/api/vpn-manager/vpn-post-cancel-support-session";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";

export const postVPNCancelSupportSessionUseCase = async (
  payload: postVPNCancelSupportSessionDto,
): Promise<{
  success: boolean;
  data?: MachinesListDataTypes;
  error?: string;
}> => {
  try {
    const response = await apiUseCases.postVPNCancelSupportSession(payload);

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to cancel support session.")
        .message,
    };
  }
};
